<template>
  <v-dialog v-if="presensiManual" v-model="dialog" scrollable max-width="700" @keydown.esc="cancel()">
    <v-card tile>
      <v-toolbar dark color="primary" dense>
        <v-toolbar-title class="white--text">Detil Presensi</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pa-5">
        <v-alert class="body-2 mb-5" dense text type="info"
          >Perbandingkan data berikut, tekan <b>Setujui</b> jika data pengguna berikut telah <b>valid atau sesuai</b>.
          Dan tekan <b>Tolak</b> jika data pengguna berikut <b>tidak sesuai</b>
        </v-alert>

        <v-row class="px-5">
          <v-col :cols="$vuetify.breakpoint.smAndUp ? 8 : 12">
            <span class="title black--text">{{ pVal(presensiManual.users, 'nama') }}</span>
            <v-chip
              class="ma-0 ml-3"
              text
              small
              dark
              outlined
              :color="$presensiManual.statusColor(presensiManual.m_status.k_status)"
              >{{ presensiManual.m_status.status }}</v-chip
            >
          </v-col>
          <v-col
            :cols="$vuetify.breakpoint.smAndUp ? 4 : 12"
            :class="$vuetify.breakpoint.smAndUp ? 'text-right' : 'text-left'"
          >
          </v-col>
          <v-col :cols="$vuetify.breakpoint.smAndUp ? 6 : 12" class="text-center">
            <span class="primary--text">Foto Presensi</span>
            <br />
            <v-avatar :size="175" color="rounded grey lighten-4 mt-3">
              <img
                :src="presensiManual.file_foto ? presensiManual.file_foto : 'img/no-image.jpeg'"
                class="grey lighten-2 pa-0"
              />
            </v-avatar>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.smAndUp ? 6 : 12" class="text-center">
            <span class="primary--text">Foto Profil</span>
            <br />
            <v-avatar :size="175" color="grey lighten-4 mt-3 rounded">
              <img
                :src="
                  presensiManual.file_foto_profil
                    ? presensiManual.file_foto_profil
                    : presensiManual.gender == 'P'
                    ? 'img/cewek.png'
                    : 'img/cowok.png'
                "
                class="grey lighten-2 pa-0"
              />
            </v-avatar>
          </v-col>
        </v-row>

        <v-row v-if="presensiManual.k_status !== 4" class="px-5 py-2">
          <v-col
            cols="12"
            sm="12"
            md="12"
            xl="12"
            :class="`mb-2 mt-5 py-0 rounded ${colors[+presensiManual.k_status].alert || 'orange'} lighten-5`"
          >
            <v-list-item two-line class="pa-0">
              <v-list-item-avatar color="primary">
                <v-icon dark>mdi-account</v-icon>
              </v-list-item-avatar>
              <v-list-item-content :class="`${colors[+presensiManual.k_status].alert || 'orange'}--text`">
                <v-list-item-title class="body-2">
                  <v-icon :color="`${colors[+presensiManual.k_status].alert || 'orange'}`" size="15"
                    >mdi-information</v-icon
                  >
                  Informasi Verifikasi
                </v-list-item-title>
                <v-list-item-subtitle class="black--text body-2 mt-1">
                  <div class="mb-1" v-if="presensiManual && presensiManual.users_admin">
                    <div class="body-1 primary--text">
                      {{ (presensiManual && presensiManual.users_admin && presensiManual.users_admin.nama) || '' }}
                    </div>
                    <div class="black--text">
                      {{ (presensiManual && presensiManual.users_admin && presensiManual.users_admin.email) || '' }} -
                      {{ (presensiManual && presensiManual.wkt_konfirmasi) || '' }}
                    </div>
                  </div>
                  <div class="mt-2">
                    <b>Keterangan:</b> <br />
                    {{ presensiManual.keterangan_tenant || presensiManual.keterangan || '' }}
                  </div>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
        <v-row class="mt-3 mb-3 pt-0 mx-2 grey lighten-4">
          <v-col cols="12" sm="12" md="12" xl="12" class="mb-0 pb-0">
            <v-list-item two-line class="pa-0">
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" md="6" xl="6" sm="6">
                    <div class="my-1">
                      <v-list-item-title class="caption primary--text"
                        ><v-icon class="primary--text" size="15">mdi-calendar</v-icon> Waktu Presensi
                      </v-list-item-title>
                      <v-list-item-subtitle class="mt-2 black--text">
                        {{ pVal(presensiManual, 'waktu_scan') | toD }}
                        {{ $setTimezone(presensiManual.waktu_scan, 2) }}
                      </v-list-item-subtitle>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6" xl="6" sm="6">
                    <div class="my-1">
                      <v-list-item-title class="caption primary--text"
                        ><v-icon class="primary--text" size="15">mdi-google-maps</v-icon> Lokasi
                      </v-list-item-title>
                      <span>{{ presensiManual.latitude }},{{ presensiManual.longitude }} &nbsp;</span>
                      <v-btn
                        small
                        depressed
                        color="primary"
                        class="ml-3 py-4"
                        @click="toMaps(presensiManual.latitude, presensiManual.longitude)"
                      >
                        <v-icon size="18">mdi-google-maps</v-icon>Cek
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-col>

          <v-col cols="12" sm="12" md="6" lg="6" v-if="activities" class="pt-0 mt-0">
            <p class="caption primary--text mb-1">
              <v-icon class="primary--text" size="15">mdi-note</v-icon> Aktivitas
            </p>
            <ul>
              <li style="color:black !important">
                <span class="font-weight-bold">{{ activities.waktu }} - </span>
                {{ activities.aktivitas }}
              </li>
            </ul>
          </v-col>
          <v-col v-if="presensiManual.status_lokasi !== null" cols="12" sm="12" lg="6" class="pt-0 mt-0">
            <div class="my-1">
              <v-list-item-title class="caption primary--text">
                <v-icon class="primary--text" size="15">mdi-map-marker-radius</v-icon> Radius Lokasi Presensi
              </v-list-item-title>
              <v-list-item-subtitle class="mt-2 black--text">
                {{
                  presensiManual.status_lokasi === 0
                    ? 'Luar Lokasi'
                    : presensiManual.status_lokasi === 1
                    ? 'Dalam Lokasi'
                    : 'Lokasi Tidak Tersedia'
                }}
              </v-list-item-subtitle>
            </div>
          </v-col>
          <v-col cols="12" sm="12" lg="6" class="pt-0 mt-0">
            <div class="my-1">
              <v-list-item-title class="caption primary--text">
                <v-icon class="primary--text" size="15">mdi-face-recognition</v-icon> Rekomendasi Deepface
              </v-list-item-title>
              <v-list-item-subtitle class="mt-2 black--text">
                <template v-if="getDeepObj(presensiManual, 'deepface.similarity')">
                  <v-progress-linear
                    rounded
                    :color="
                          Number(getDeepObj(presensiManual, 'deepface.similarity')) >= 70
                            ? 'success'
                            : Number(getDeepObj(presensiManual, 'deepface.similarity')) < 70 &&
                              Number(getDeepObj(presensiManual, 'deepface.similarity')) >= 50
                            ? 'orange'
                            : 'red'
                        "
                    height="13"
                    :value="Number(getDeepObj(presensiManual, 'deepface.similarity'))"
                  >
                        <span class="white--text caption" style="margin-top: 1pt">
                          {{ getDeepObj(presensiManual, 'deepface.similarity') }}%
                        </span>
                  </v-progress-linear>
                </template>
                <template v-else>
                  <span class="orange--text">Belum ada rekomendasi</span>
                </template>
              </v-list-item-subtitle>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider class="mb-5"></v-divider>
      <v-card-actions v-if="[4, 5, 7].includes(presensiManual.k_status) && isCan('presensi-manual.approval')">
        <v-spacer></v-spacer>
        <v-btn
          v-if="presensiManual.k_status == 4"
          class="mr-2 mb-2"
          depressed
          color="success"
          @click="setujui(presensiManual)"
        >
          <v-icon>mdi-check</v-icon>Setujui </v-btn
        >&nbsp;
        <v-btn
          v-if="presensiManual.k_status == 4"
          class="mr-2 mb-2"
          depressed
          color="error"
          @click="tolak(presensiManual)"
        >
          <v-icon>mdi-close</v-icon>Tolak
        </v-btn>
        <v-btn
          v-if="presensiManual.k_status == 5 && current_user.is_admin === 1"
          class="mr-2 mb-2"
          depressed
          color="error"
          @click="tolakPermanen(presensiManual)"
        >
          <v-icon>mdi-close</v-icon>Tolak Permanen
        </v-btn>
        <v-btn
          v-if="presensiManual.k_status == 7 && current_user.is_admin === 1"
          class="mr-2 mb-2"
          depressed
          color="warning"
          @click="batalTolak(presensiManual)"
        >
          <v-icon left>mdi-lock-reset</v-icon> Batal Tolak
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      activities: null,
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      keterangan: null,
      organisasi: null,
      role: null,
      options: {},
      presensiManual: null,
      items: [],
      textSearch: null,
      page: null,
      cp: 1,
      user: {},
      headers: [
        { text: 'Nama', align: 'left', value: 'nama' },
        { text: '', align: 'left', sortable: false },
      ],
      colors: {
        5: {
          alert: 'green',
        },
        6: {
          alert: 'red',
        },
        7: {
          alert: 'red',
        },
      },
    }
  },
  computed: {},
  methods: {
    // eslint-disable-next-line
    open(item, title, message) {
      this.presensiManual = item
      this.organisasi = []
      this.role = []
      this.user = {}
      this.keterangan = null
      this.title = title || 'Konfirmasi'
      this.message = message

      this.load(item)
      this.loadAktivitas(item)

      this.dialog = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    toMaps(lat, long) {
      var url = 'http://www.google.com/maps/place/' + lat + ',' + long
      window.open(url, '_blank')
    },
    load(item) {
      return this.$store
        .dispatch('presensiManual/detail', {
          presensi_manual_id: item.presensi_manual_id,
          organisasi_id: item.organisasi.no_reg,
        })
        .then((res) => {
          this.presensiManual = res.data
        })
        .catch((e) => e)
    },
    loadAktivitas(obj) {
      this.$store
        .dispatch('riwayatKehadiran/getActivityManual', obj.presensi_manual_id)
        .then((res) => {
          this.activities = res.data
        })
        .catch((e) => e)
    },
    loadUser(item) {
      this.$store
        .dispatch('user/detail', {
          organisasi_id: item.organisasi.no_reg,
          user_id: item.user_id,
        })
        .then(({ data }) => {
          this.user = data || {}
        })
    },
    batalTolak(item) {
      this.$infoDlg(
        `Apakah Anda yakin akan melakukan batal tolak permanen data presensi berikut ?
      `,
        'Batal Tolak Permanen'
      )
        .then(() => {
          return this.$store.dispatch('presensiManual/batalTolak', {
            presensi_manual_id: item.presensi_manual_id,
            organisasi_id: item.organisasi.no_reg,
          })
        })
        .then((res) => {
          this.dialog = false
          return this.resolve(res)
        })
        .catch((e) => e)
    },
    setujui(item) {
      this.$successDlg(
        `Apakah Anda yakin akan menyetujui data presensi ini?<br><br>
        <div class="mt-2 title grow text-center">
        </div>
      `,
        {
          keterangan: {
            label: 'Silakan Tulis Alasan Menyetujui Presensi di Sini',
          },
        },
        'Setujui Presensi Swafoto'
      )
        .then((res) => {
          item.keterangan = res.keterangan
          item.k_status = 5
        })
        .then(() => {
          return this.$store.dispatch('presensiManual/approve', {
            presensi_manual_id: item.presensi_manual_id,
            organisasi_id: item.organisasi.no_reg,
            obj: item,
          })
        })
        .then((res) => {
          this.dialog = false
          return this.resolve(res)
        })
        .catch((e) => e)
    },
    tolakPermanen(item) {
      this.$confirmDanger(
        `Apakah Anda yakin akan menolak permanen data presensi ini ?<br><br>
        <div class="mt-2 title grow text-center">
        </div>
      `,
        {
          keterangan: {
            label: 'Silakan Tulis Alasan Tolak Permanen Presensi di Sini',
          },
          color: 'red',
          btnColor: 'success',
        },
        'Tolak Presensi Swafoto'
      )
        .then((res) => {
          item.keterangan = res.keterangan
          item.k_status = 7
        })
        .then(() => {
          return this.$store.dispatch('presensiManual/rejectPermanen', {
            presensi_manual_id: item.presensi_manual_id,
            organisasi_id: item.organisasi.no_reg,
            obj: {
              k_status: 6,
              keterangan: item.keterangan,
            },
          })
        })
        .then((res) => {
          this.dialog = false
          return this.resolve(res)
        })
        .catch((e) => e)
    },
    tolak(item) {
      this.$confirmDanger(
        `Apakah Anda yakin akan menolak data presensi ini ?<br><br>
        <div class="mt-2 title grow text-center">
        </div>
      `,
        {
          keterangan: {
            label: 'Silakan Tulis Alasan Tolak Presensi di Sini',
          },
          color: 'red',
          btnColor: 'success',
        },
        'Tolak Presensi Swafoto'
      )
        .then((res) => {
          item.keterangan = res.keterangan
          item.k_status = 6
        })
        .then(() => {
          return this.$store.dispatch('presensiManual/reject', {
            presensi_manual_id: item.presensi_manual_id,
            organisasi_id: item.organisasi.no_reg,
            obj: item,
          })
        })
        .then((res) => {
          this.dialog = false
          return this.resolve(res)
        })
        .catch((e) => e)
    },
  },
}
</script>
<style>
.vue-map-container,
.vue-map-container .vue-map {
  width: 100%;
  height: 95%;
}
</style>
